import { CheckBoxChangeEvent } from 'components/CheckBox'
import { ChangeEvent, useEffect, useState } from 'react'
import { useSession } from 'hooks/useSession'
import { useToast } from 'hooks/useToast'
import { BaseRoutes } from 'routes/BaseRoutes'
import { useHistory } from 'react-router'
import { useAuth } from 'hooks/useAuth'

type Definition = "CREATE" | "READ" | "UPDATE" | "DELETE"

interface RoleProps {
  roleName: string,
  definitions: Definition[],
}

const initRole:RoleProps = {
  roleName: '',
  definitions: [],
}

export const useNewRole = () => {
  const [role, setRole] = useState<RoleProps>(initRole);
  const [loading, setLoading] = useState(false);
  const [invalidForm, setInvalidForm] = useState(true);
  const history = useHistory();
  const {connectApi} = useAuth();

  useEffect(()=>{
    if (role.roleName.length > 0 && role.definitions.length > 0) {
      setInvalidForm(false);
    } else {
      setInvalidForm(true);
    }
  }, [role])

  const push = (route: string): void => {
    history.push(route);
  }

  const createPermission = async() => {
    setLoading(true);
    connectApi({
      type: 'post',
      url: 'users/roles',
      body: role,
      successMessage: `Permissão cadastrada com sucesso`,
    })
    .then((_) => push(BaseRoutes.permissions))
    .finally(() => setLoading(false))
  }

  const handleInputFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setRole({
      ...role,
      roleName: value,
    })
  }

  const handleCheckBoxChange = (e: CheckBoxChangeEvent) => {
    const enabled:boolean = e.checked;
    const definition:Definition = e.value;
    let roleDefinitions = [...role.definitions];

    if (enabled) {
      roleDefinitions.push(definition);
    } else {
      const index = roleDefinitions.indexOf(definition, 0);
      if (index > -1) {
        roleDefinitions.splice(index, 1);
      }
    }
    
    setRole({
      ...role,
      definitions: roleDefinitions,
    });
  }

  const handleOnSubmit = () => {
    createPermission();
  }

  return {
    loading,
    invalidForm,
    role,
    handleInputFieldChange,
    handleCheckBoxChange,
    handleOnSubmit
  }
}